<template>
	<div class="min-h-screen max-w-screen w-full surface-ground ">
		<NavBar :breadcrumbs="breadcrumbs"></NavBar>
		<div class="h-full fixed " style="z-index:1; top:84px">
			<UserSidebar :user-id="userId"></UserSidebar>
		</div>
		<div class="flex pageview" style="padding-top: 84px; min-height: calc(100vh - 84px);">
			<div :class="contentContainerClass" >
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import UserSidebar from './UserSidebar';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
	inject: ['hasPermission'],
	name: 'UserLayout',
	components: {
		UserSidebar,
	},

	props: ['userId'],

	setup(props) {
		const store = useStore()
		const route = useRoute();

		const breadcrumbs = computed(() => {
			var user = store.getters['users/user'](props.userId)
			return [
				{ title: "Users", route: "users" },
				{ title: user ? user?.firstName + ' ' + user?.lastName : '...', route: "user-general" },
				{ title: route.meta?.breadcrumb ?? "..." }
			]
		})

		const contentContainerClass = computed(() => {
			// Check if we're on pages that use the modern gradient background
			const modernPages = ['user-general', 'user-member-cards']
			if (modernPages.includes(route.name)) {
				return 'w-full general-user-container'
			}
			// Default styling for other user pages
			return 'w-full surface-section px-6 pt-0'
		})

		return { breadcrumbs, contentContainerClass }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.pageview {
	margin-left: 280px;
}

.general-user-container {
	background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%);
	min-height: 100vh;
	background-attachment: fixed;
}

@media screen and (max-width: 991px) {
	.pageview {
		margin-left: 0px;
	}
}
</style>
